import { RAL_TO_HEX } from '@cutr/constants/colors';
import { PaintColorValue as PaintColorValueType } from '@cutr/constants/windows/windows-configurations.ts';

import { unboxLabel } from '../Configurations';
import styles from './PaintColorValue.module.css';

const resolveColor = (value: PaintColorValueType) => {
  switch (value.colorType) {
    case 'RAL':
      return value.r !== '' && value.g !== '' && value.b !== ''
        ? `rgb(${value.r}, ${value.g}, ${value.b})`
        : RAL_TO_HEX[`RAL${value.ralCode}`] || '#FFFFFF';
    case 'regular':
      return `rgb(${value.r || '0'}, ${value.g || '0'}, ${value.b || '0'})`;
    case 'none':
      return null;
  }
};

export const PaintColorSwatch = ({ value }: { value: PaintColorValueType }) => {
  const color = resolveColor(value);
  if (!color) {
    return null;
  }
  return (
    <span
      className={styles.colorValue}
      style={{
        backgroundColor: color,
        borderBottomColor: 'transparent',
      }}
    />
  );
};

export const PaintColorValue = ({
  value,
  label,
}: {
  value?: PaintColorValueType;
  label?: string;
}) => {
  if (!value) {
    return '-';
  }
  return (
    <span className={styles.colorValueContainer}>
      <PaintColorSwatch value={value} />
      <span>{label ?? unboxLabel(value.label)}</span>
    </span>
  );
};
